import { LitElement, html } from "lit-element";
import { colorTheme } from "../styles/color-theme"

export class ImageSettingsPopup extends LitElement {
	render() {
		return html`
            ${colorTheme}
            <style>
                :host {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    z-index: 9999;
                    display: flex;
                    justify-content: center;
                    background-color: #4e4e58b8;
                }

                .popup {
                    padding: 20px;
                    align-self: center;
                    background-color: var(--primary-color-variant1);
                }

                mwc-button {
                    --mdc-theme-primary: var(--secondary-color);
                    width: 100%
                }

                .title {
                    color: var(--secondary-color);
                }
            </style>
            <div class="popup">
                <div class="title">Image settings</div>
                <text-box type="text" label="Name"
                    .value="${this.name}" 
                    @change="${e => (this.name = e.currentTarget.value)}"></text-box>
                <text-box type="multiline" label="Description"
                    .value="${this.description}"
                    @change="${e => (this.description = e.currentTarget.value)}"></text-box>
                <div class="button-box">
                    <mwc-button @click="${this.closeFunc}" label="Close"></mwc-button>
                    <mwc-button @click="${this.handleUpdate}" label="Apply"></mwc-button>
                </div>
            </div>`;
	}

	closeFunc() {
		this.closeCallback()
		this.remove();
	}
    
    handleUpdate() {
        if (this.name === "signature") {
            this.closeFunc();
            return;
        }
		const updatedData = { propertyName: this.name, description: this.description }
		this.applyFunc(this.id, updatedData, this.drawing)
		this.applyCallback(this.name, this.description)
		this.remove();
	}

	constructor(name, description, id, applyFunc, drawing) {
		super();
		this.name = name;
		this.description = description;
		this.id = id;
		this.applyFunc = applyFunc
		this.drawing = drawing
	}
}

window.customElements.define("inspx-image-settings-popup", ImageSettingsPopup);

